import { createRouter, createWebHistory } from 'vue-router'
import routes from './routes'

//创建路由
const router = createRouter({
  //history模式
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    return {
      top: 0,
    }
    // const top: number = savedPosition?.top || 0
    // const left: number = savedPosition?.left || 0
    // //  异步滚动
    // return new Promise((resolve) => {
    //   setTimeout(() => {
    //     resolve({ top, left, behavior: 'smooth' })
    //   }, 50)
    // })
  },
})

//全局前置守卫
// router.beforeEach((to, from,next) => {})

//全局解析守卫
// router.beforeResolve((to) => {})

//全局后置守卫
// router.afterEach((to, from) => {})

export default router
